import React from 'react';

const PDHeader1 = (props) => {
    {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <h2 id="productName">{props.item.ProductName}</h2>
                        {props.item.ProductTag1 !== "" ? < h3 id="productTag1">{props.item.ProductTag1}</h3> : null}
                        <div id="highlightdetails">
                            test
                    </div>
                    </div>
                    <div className="col-4">
                        <img height="300px" src={props.item.PictureLink}></img>
                    </div>
                </div>
            </div >
        )
    }

}

export default PDHeader1;